import { useDispatch, useSelector } from "react-redux";
import { saveUserOptions } from "@store/persistedappdata";

import { logFilter } from "@logging";

const tag = "UserOptions";

// each of these USEROPTION* MUST be in contact_options_template database table
export const USEROPTION_CHART_SHOWGAPS = "chart_showGaps";
export const USEROPTION_CHART_TOOLTIP_PLACEMENT = "chart_tooltipPlacement";
export const USEROPTION_STARTPAGE = "default_start_page";
export const USEROPTION_DEFAULT_BUILDINGS_LIST_EXPAND_VIEW =
  "default_buildings_list_expand_view";
export const USEROPTION_DEFAULT_DASHBOARD_PANE = "default_dashboard_pane";
export const USEROPTION_DEFAULT_SEARCH_VISIBLE = "default_search_visible";
export const USEROPTION_IAQ_USE_AVERAGE = "iaq_useAverage";
export const USEROPTION_DEBUG_SHOWSITEID = "debug_showSiteId";
export const USEROPTION_DEBUG_SHOWDATAPOINTID = "debug_showDatapointId";
export const USEROPTION_DEBUG_SHOWDATAPOINTTYPE = "debug_showDatapointType";
export const USEROPTION_DEBUG_SHOWISTOTALIZER = "debug_showIsTotalizer";
export const USEROPTION_DEBUG_SHOWCONTACTID = "debug_showContactId";
export const USEROPTION_DEBUG_SHOWEQUIPMENTID = "debug_showEquipmentId";
export const USEROPTION_ADMIN_WELLSTAT = "admin_WellStat";

export const useUserOptions = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.persistedAppData.userinfo);
  const userOptionTemplates = useSelector(
    (state) => state.persistedAppData.lookupdata?.useroptiontemplates,
  );

  const get = (key, failSafeValue) => {
    if (userInfo?.options?.hasOwnProperty(key)) return userInfo.options[key];

    const templateValue = userOptionTemplates?.find(
      (e) => e.option_name === key,
    );
    return templateValue
      ? JSON.parse(templateValue.option_value)
      : failSafeValue;
  };

  const set = (key, value) => {
    logFilter(
      tag,
      "setUserOptions",
      key,
      value,
      `[${value}]`,
      JSON.stringify(value),
    );
    dispatch(
      saveUserOptions({
        options: { contact_id: userInfo.contact_id },
        payload: [{ option_name: key, option_value: value }],
      }),
    );
  };

  return { get, set };
};
